import React from 'react';
import './home.scss';

export default function Home() {
  return (
    <React.Fragment>
      <h2 className={'content-block'}>Home</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          <div className={'logos-container'}>
            <img src="https://innkep.de/wp-content/uploads/2024/07/innKEP.-LOGO-mit-Slogan-768x506.webp" alt="" style={{ display: 'block', margin: 'auto' }}/>                      
          </div>          
        </div>
      </div>
    </React.Fragment>
)}
